<div *ngIf="loading; else loaded">Loading...</div>
<ng-template #loaded>
  <div *ngIf="colorSettingAudits && colorSettingAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="colorSettingAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Color Setting audits </ng-template>
</ng-template>
